import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SarFaslAmozeshiService {

  constructor(private http:HttpClient) { }


  GetRecord(Token:String):Observable<Array<General_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/SarFaslAmozeshi?token="+Token).pipe(
      map(data=>{
        return data as Array<General_Interface>
      })
    )
  }

  GetActiveList(Token:String):Observable<Array<General_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/SarFaslAmozeshi/GetActiveList?token="+Token).pipe(
      map(data=>{
        return data as Array<General_Interface>
      })
    )
  }

  GetSingle(Token:String,id:Number):Observable<General_Interface>{
    return this.http.get(environment.BaseUrl + "Daro/SarFaslAmozeshi/GetSingle?token="+Token+"&id="+id).pipe(
      map(data=>{
        return data as General_Interface
      })
    )
  }

  AddSarFaslAmozeshi(model: General_Interface,Token:String):Observable<General_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id:model.id,
      title:model.title,
      del:false,
      username:Token,
      subdate:null
    }


      return this.http.post(environment.BaseUrl + "Daro/SarFaslAmozeshi/Add",body,{headers}).pipe(
        map(data=>{
          return data as General_Interface
        })
      )

  }

  EditSarFaslAmozeshi(model: General_Interface,Token:String):Observable<General_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id:model.id,
      title:model.title,
      del:false,
      username:Token,
      subdate:null
    }


      return this.http.post(environment.BaseUrl + "Daro/SarFaslAmozeshi/Edit",body,{headers}).pipe(
        map(data=>{
          return data as General_Interface
        })
      )

  }

  DeleteSarFaslAmozeshi(id:number,Token:String):Observable<General_Interface>{

      return this.http.get(environment.BaseUrl + "Daro/SarFaslAmozeshi/Delete?id="+id+"&token="+Token).pipe(
        map(data=>{
          return data as General_Interface
        })
      )

  }

  }
